/* global localStorage */
import { isPlainObject, merge } from 'lodash'

function AliadaAnalyticsPersistence (config = {}) {
  this.name = config.storageName
  this.props = {}
  this._load()
}

const persistence = AliadaAnalyticsPersistence.prototype

persistence._load = function () {
  let props = {}

  const stringifiedProps = localStorage.getItem(this.name)
  props = JSON.parse(stringifiedProps)

  if (props === null) {
    props = {}
    const stringifiedProps = JSON.stringify(props)
    localStorage.setItem(this.name, stringifiedProps)
  }

  this.props = props
}

persistence._save = function () {
  localStorage.setItem(
    this.name,
    JSON.stringify(this.props)
  )
}

persistence.register = function (props) {
  if (!isPlainObject(props)) {
    console.error('AliadaAnalyticsPersistence#register can only be called with a plain object')
    return
  }

  merge(this.props, props)
  this._save()
}

persistence.registerOnce = function (props) {
  if (!isPlainObject(props)) {
    console.error('AliadaAnalyticsPersistence#registerOnce can only be called with a plain object')
    return
  }

  const newProps = {}

  Object.keys(props).forEach((key) => {
    if (key in this.props) {
      return
    }

    newProps[key] = props[key]
  })

  this.register(newProps)
}

persistence.clear = function () {
  this.props = {}
  localStorage.removeItem(this.name)
}

persistence.properties = function () {
  return this.props
}

export default AliadaAnalyticsPersistence



// WEBPACK FOOTER //
// ./src/services/aliada-analytics/persistence.js